import React from 'react';
import NavBar from '../components/NavBar';


export default function Pricing() {
  return (
    <div>
      <NavBar />
      <h1>Pricing</h1>
    </div>
  );
}
